import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { TicketsService } from '@/services';

interface SlaAlert {
  total: number;
  tickets: Array<{
    id: number;
    assunto: string;
    departamento_id: number | null;
    departamento_nome: string;
    prioridade: string;
    tempo_atras: string;
    sla_valor: number;
    sla_unidade: string;
  }>;
}

export function useSlaAlerts() {
  const { usuario } = useAuth();
  const [slaAlerts, setSlaAlerts] = useState<SlaAlert | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const verificarSlaEstourado = useCallback(async () => {
    // Só verifica se o usuário for admin ou dev
    if (!usuario || (usuario.nivel !== 'admin' && usuario.nivel !== 'dev')) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const response = await TicketsService.getTicketsSlaEstourado();
      
              if (response.success) {
          setSlaAlerts(response.data);
        } else {
        setError(response.error || 'Erro ao verificar SLA');
      }
    } catch (err) {
      setError('Erro ao verificar SLA estourado');
      console.error('Erro ao verificar SLA:', err);
    } finally {
      setLoading(false);
    }
  }, [usuario]);

  // Verificar SLA quando o componente montar e a cada 5 minutos
  useEffect(() => {
    verificarSlaEstourado();
    
    const interval = setInterval(verificarSlaEstourado, 5 * 60 * 1000); // 5 minutos
    
    return () => clearInterval(interval);
  }, [verificarSlaEstourado]);

  return {
    slaAlerts,
    loading,
    error,
    verificarSlaEstourado
  };
}
